module.exports = __webpack_public_path__ + "img/Cuba1.7cfbeabd.png";